import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const authHeader = () => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('gv_admin_token')}` };
  const selectedOrg = localStorage.getItem('gv_selected_org');
  if (selectedOrg) {
    try {
      const { id } = JSON.parse(selectedOrg);
      if (id) headers['X-Org-Id'] = id;
    } catch (_) {}
  }
  return { headers };
};

export const api = {
  get:    (url, cfg = {})       => axios.get(`${API_BASE}${url}`, { ...authHeader(), ...cfg }),
  post:   (url, data, cfg = {}) => axios.post(`${API_BASE}${url}`, data, { ...authHeader(), ...cfg }),
  put:    (url, data, cfg = {}) => axios.put(`${API_BASE}${url}`, data, { ...authHeader(), ...cfg }),
  patch:  (url, data, cfg = {}) => axios.patch(`${API_BASE}${url}`, data, { ...authHeader(), ...cfg }),
  delete: (url, cfg = {})       => axios.delete(`${API_BASE}${url}`, { ...authHeader(), ...cfg }),
};